import React from "react";

export const Image6 = ({ title6, largeImage6, smallImage6 }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={largeImage6} title6={title6} data-lightbox-gallery="gallery6">
          <div className="hover-text">
            <h4>{title6}</h4>
          </div>
          <img src={smallImage6} className="img-responsive" alt={title6} />{" "}
        </a>{" "}
        
      </div>
    </div>
    
  );
};
